export const testAttributes = {
    CARD_ROOT: 'cta-card-root',
    CARD_ILLUSTRATION: 'cta-card-illustration',
    CARD_TITLE: 'cta-card-title',
    CARD_BUTTON: 'cta-card-button',
    CARD_BUTTON_ICON: 'cta-card-button-icon',
}